import httpService from './httpService';

const transliterate = <T>(data: T): Promise<T> => httpService.post('/api/v1/external/transliterate/', data);
export default transliterate;
